import React from "react";
import InvoiceTableRow from "./InvoiceTableRow";

const InvoiceItemsTable = ({ invoice, invoices }) => (
  <InvoiceTableRow invoice={invoice} invoices={invoices} />
);

export default InvoiceItemsTable;
